import { css } from '@emotion/css';
import { ColorConstant, Font, FontWeight, Spacing } from 'src/styles';

export const statusLabel = css`
  ${FontWeight.bold};
  ${Font.h2};
  ${Spacing.mt24}
  color: ${ColorConstant.GRAY10};
`;

export const investigationTitle = css`
  ${FontWeight.bold};
  ${Font.lg};
  color: ${ColorConstant.GRAY8};
`;

export const investigationDescription = css`
  ${Font.md};
  color: ${ColorConstant.GRAY7};
`;

// AccountStatus styles
export const upload = css`
  .ant-upload-list-item-info {
    ${Spacing.mt0}
  }
`;
